import { Wishlist } from '../../models'

export const MB_WISHLIST_FEATURE = 'mbWishlistContext'

export interface MbStateWithWishlistContext {
  [MB_WISHLIST_FEATURE]: WishlistState;
}

export interface WishlistState {
  defaultWishlist?: Wishlist;
}
